import React from 'react';
import styles from '../assets/scss/pagesScss/about.module.scss';
import { FaCheckCircle, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import Hearder from '../component/common/header';
import { aboutData, benefitsData, teamData } from '../assets/config/config';
import { Link } from 'react-router-dom';
import ServiceSections from '../component/homeComponnets/servicesection';

export default function About() {
    return (
        <>
            <Hearder title="About us" breadcrumb="About us" />

            {/* About Section */}
            <section className={styles.aboutSection}>
                <div className="container">
                    <div className={styles.at_wrp}>
                        <div className={styles.imageContainer}>
                            <img src={aboutData.image} alt="About Us" className={styles.aboutImage} />
                            <div className={styles.experienceBox}>
                                <span className={styles.experienceYears}>{aboutData.experience.years}</span>
                                <span className={styles.experienceText}>{aboutData.experience.text}</span>
                            </div>
                        </div>

                        <div className={styles.contentContainer}>
                            <span className={styles.subtitle}>{aboutData.subtitle}</span>
                            <h2 className={styles.title}>{aboutData.title}</h2>
                            {aboutData.description.map((paragraph, index) => (
                                <p key={index} className={styles.description}>
                                    {paragraph}
                                </p>
                            ))}
                            {window.location.pathname === '/about' ? null :  (
                            <Link to={aboutData.button.link} className={styles.moreInfoButton}>
                                {aboutData.button.text} <i className='fa fa-right-arrow'></i>
                            </Link>
                            )}
                        </div>
                        <img className={styles.span_img} src="/images/aboutspan.png" alt="About Us" />
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            {/* <section className={styles.benefitsSection}>
                <div className="container">
                    <h2 className={styles.sectionTitle}>By Joining WEEKENS UX Platform, One Can Avail a Lot Of Benefits.</h2>
                    <p className={styles.sectionSubtitle}>
                        Install our top-rated dropshipping app to your e-commerce site and get access to US suppliers, AliExpress vendors, and the best.
                    </p>
                    <div className={styles.benefitsGrid}>
                        {benefitsData.map((benefit, index) => (
                            <div key={index} className={styles.benefitCard}>
                                <span className={styles.benefitNumber}>{`0${index + 1}`}</span>
                                <div className={styles.benefitIcon}><FaCheckCircle /></div>
                                <h3 className={styles.benefitTitle}>{benefit.title}</h3>
                                <p className={styles.benefitDescription}>{benefit.description}</p>
                                <Link to={benefit.link} className={styles.readMore}>Read More</Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}
            <ServiceSections />


            {/* Team Section */}
            {/* <section className={styles.teamSection}>
                <div className="container">
                    <h2 className={styles.sectionTitle}>Meet the Heroes</h2>
                    <p className={styles.sectionSubtitle}>
                        On Weekend UX, instructors from all over the world instruct millions of students. We offer the knowledge and abilities.
                    </p>
                    <div className={styles.teamGrid}>
                        {teamData.map((member, index) => (
                            <div key={index} className={styles.teamCard}>
                                <img src={member.image} alt={member.name} className={styles.teamImage} />
                                <h3 className={styles.teamName}>{member.name}</h3>
                                <p className={styles.teamRole}>{member.role}</p>
                                <div className={styles.teamIcons}>
                                    <a href={member.social.facebook}><FaFacebook /></a>
                                    <a href={member.social.twitter}><FaTwitter /></a>
                                    <a href={member.social.linkedin}><FaLinkedin /></a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}
        </>
    );
}
